﻿import TKAssetGallery from '@tk/components/tk.asset.gallery';

export default class KWAssetGallery extends TKAssetGallery {
    openPreview?: HTMLElement;
    isVertical: boolean;
    countHeightElements?: NodeListOf<HTMLElement>;
    countLabel?: HTMLElement;

    constructor() {
        super();

        this.openPreview = this.querySelector('[data-open-preview]') || undefined;
        this.isVertical = this.hasAttribute('data-is-vertical');
        this.countHeightElements = this.querySelectorAll('[data-count-height]');
        this.countLabel = this.querySelector('[data-count-label]') || undefined;
    }

    connectedCallback(): void {
        super.connectedCallback();
        this.countThumbnails();
        this.isVertical && this.resizeThumbnailHeight();
    }

    countThumbnails() {
        if (!this.countLabel) return;
        const text = this.thumbnailCount === 1
            ? window.opacc.projectGeneralMessages?.assetGalleryCountSingle.text
            : window.opacc.projectGeneralMessages?.assetGalleryCountMultiple.text;
        this.countLabel.textContent = (
            (text || '').replace('%1', String(this.thumbnailCount))
        );
    }

    resizeThumbnailHeight() {
        if (!this.thumbnails) return;
        let maxHeight = 0;
        this.countHeightElements?.forEach((element) => {
            const { height } = element.getBoundingClientRect();
            maxHeight += height;
        });
        const { gap } = window.getComputedStyle(this);
        const gapSize = parseInt(gap, 10);
        maxHeight += gapSize * (this.countHeightElements?.length || 1 - 1);

        this.thumbnails.style.maxHeight = `${maxHeight}px`;
    }

    registerClickListener(): void {
        super.registerClickListener();

        if (!this.openPreview) return;
        const handlePreviewClick = this.toggleFullscreen.bind(this);
        this.pushListener({ event: 'click', element: this.openPreview, action: handlePreviewClick });
    }

    optimizeThumbnails() {
        this.moreButton && (this.moreButton.hidden = true);
        let size = 0;
        let scrollSize = 0;
        if (this.isVertical) {
            const { scrollHeight } = this.thumbnails!;
            const { height } = this.thumbnails!.getBoundingClientRect();
            size = height;
            scrollSize = scrollHeight;
        } else {
            const { scrollWidth } = this.thumbnails!;
            const { width } = this.thumbnails!.getBoundingClientRect();
            size = width;
            scrollSize = scrollWidth;
        }
        if (size >= scrollSize) return;
        const childrenList = this.getFilteredThumbnails();
        const closestHiddenChild = childrenList.find((child) => {
            const childRect = child.getBoundingClientRect();
            const { right, bottom } = this.thumbnails!.getBoundingClientRect();
            if (this.isVertical) {
                const childBottom = childRect.bottom;
                return bottom < childBottom;
            }
            const childRight = childRect.right;
            return right < childRight;
        });
        if (!closestHiddenChild) return;
        const index = childrenList.indexOf(closestHiddenChild);
        this.thumbnailShowingCount = index - 1;
        this.trimThumbnailsToMaxCount(childrenList, this.thumbnailShowingCount);
        this.moreButton && (this.moreButton.hidden = false);
    }
}